import React, { useCallback, useEffect } from 'react';
import classnames from 'classnames';

// Types
import { Toast } from './types';

// Constants
import ColorConstants from '../../colors/ColorConstants';

// Components
import WpIcon from '../icon/WpIcon';
import { WpButton, WpButtonGroup } from '../button';
import { WpText } from '../text';

import './WpToast.scss';

const defaultOptions = {
  variant: 'success',
  autoDismiss: true,
  showDismissBtn: true,
  actionBtnLabel: null,
  actionBtnFnc: null,
};

type Props = {
  toast: Toast;
  removeToast: Function;
};
const WpToast: React.FC<Props> = ({ toast, removeToast }: Props) => {
  const options = { ...defaultOptions, ...toast.options };

  const dismissToast = () => removeToast(toast);

  useEffect(() => {
    if (options.autoDismiss) setTimeout(() => dismissToast(), 5000);
  }, [toast, options]);

  const handleActionBtnClick = useCallback(() => {
    dismissToast();
    // need a little  timeout to allow
    // the toast to be removed first
    setTimeout(() => {
      options.actionBtnFnc();
    }, 0);
  }, [options, removeToast, toast]);

  const renderIcon = () => {
    switch (options.variant) {
      case 'success':
        return <WpIcon prefix="fas" name="check-circle" size="lg" color={ColorConstants.green[500]} />;
      case 'warning':
        return <WpIcon prefix="fas" name="exclamation-triangle" size="lg" color={ColorConstants.yellow[500]} />;
      case 'danger':
        return <WpIcon prefix="fas" name="exclamation-circle" size="lg" color={ColorConstants.red[600]} />;
      case 'info':
      default:
        return null;
    }
  };

  const showActionButton = options.actionBtnLabel && options.actionBtnFnc;
  const showDismissBtn = options.showDismissBtn;

  const baseClassName = 'WpToast';
  const classes = classnames(baseClassName, `${baseClassName}--${options.variant}`);
  return (
    <div className={classes}>
      {options.variant !== 'info' && <div className="WpToast__icon">{renderIcon()}</div>}
      <div className="WpToast__message">
        <WpText variant="bodySm" noMargin color="white-0">
          {toast.message}
        </WpText>
      </div>
      <WpButtonGroup spacing="sm">
        {showActionButton && (
          <WpButton size="sm" onClick={handleActionBtnClick} color="white">
            {options.actionBtnLabel}
          </WpButton>
        )}
        {showDismissBtn && (
          <WpButton size="sm" variant="tertiary" color="white" onClick={dismissToast}>
            <WpIcon name="times" />
          </WpButton>
        )}
      </WpButtonGroup>
    </div>
  );
};

export default WpToast;
